/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Type_PlaceholderInputs */

const en__field_type_placeholder = /** @type {(inputs: _Field_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type of the extracted information`)
};

/** @type {(inputs: _Field_Type_PlaceholderInputs) => LocalizedString} */
const de__field_type_placeholder = en__field_type_placeholder;

/**
* | output |
* | --- |
* | "Type of the extracted information" |
*
* @param {_Field_Type_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_type_placeholder = /** @type {((inputs?: _Field_Type_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Type_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_type_placeholder(inputs)
	return de__field_type_placeholder(inputs)
});